import { api } from '@/lib/api'


interface ApiPermission {
  id: string
  key: string
  label: string
  group_name: string
  sort_order: number
}

interface ApiRole {
  role_id: number
  name: string
  keys: string[]
  user_count: number
}

interface ApiEnvelope<T> {
  status: number
  message: string
  data: T
}


export const DB_NAME_TO_KEY: Record<string, string> = {
  ROLE_SUPER_ADMIN: 'super_admin',
  ROLE_SUPER_FINANCE: 'super_finance',
  ROLE_SUPPORT: 'support',
  ROLE_ADMIN: 'admin',
  ROLE_FINANCE: 'finance',
  ROLE_ANALYST: 'analyst',
  ROLE_USER: 'viewer',
}


export interface PermissionItem {
  id: string
  key: string
  label: string
  groupName: string
  sortOrder: number
}

export interface RoleData {
  roleId: number
  name: string
  key: string
  keys: string[]
  userCount: number
}


export async function fetchPermissions(): Promise<PermissionItem[]> {
  const res = await api.get<ApiEnvelope<ApiPermission[]>>('/api/v1/permissions')
  return (res.data ?? []).map((p) => ({
    id: p.id,
    key: p.key,
    label: p.label,
    groupName: p.group_name,
    sortOrder: p.sort_order,
  }))
}

export async function fetchRoles(): Promise<RoleData[]> {
  const res = await api.get<ApiEnvelope<ApiRole[]>>('/api/v1/roles')
  return (res.data ?? []).map((r) => ({
    roleId: r.role_id,
    name: r.name,
    key: DB_NAME_TO_KEY[r.name] ?? r.name.toLowerCase(),
    keys: r.keys ?? [],
    userCount: r.user_count ?? 0,
  }))
}

export async function updateRolePermissions(roleId: number, keys: string[]): Promise<void> {
  await api.put(`/api/v1/roles/${roleId}/permissions`, { keys })
}

export async function fetchMyPermissions(): Promise<string[]> {
  const res = await api.get<ApiEnvelope<string[]>>('/api/v1/me/permissions')
  return res.data ?? []
}
